/* eslint-disable react-hooks/exhaustive-deps */
import {BaseButton, BaseLoading, BasePopup, Icon} from "components"
import styles from "./PreviewDocument.module.css"
import {PDFViewer} from "components/FileViewer"
import {documentService} from "services"
import {downloadFileFromUrl, handleError} from "helpers"
import {useQuery} from "@tanstack/react-query"
import {useCallback} from "react"

type Props = {
    userDocumentId?: number
    isVisible: boolean
    onClose: () => void
    goToDetails: (document: any) => void
}

export function PreviewDocument(props: Props) {
    const {userDocumentId, isVisible, onClose, goToDetails} = props

    const {
        data: document,
        isLoading,
        isFetching,
        refetch
    } = useQuery(["document-details", userDocumentId], () => documentService.getDocumentDetail(userDocumentId), {
        onError: (err) => {
            handleError(err)
        },
        enabled: userDocumentId !== null && isVisible,
        refetchOnMount: true
    })

    const goDetails = useCallback(() => {
        goToDetails(document)
    }, [document])

    return (
        <BasePopup isShow={isVisible} onClose={onClose} isShowLeftSide={false} width="70vw" closable={false}>
            <div>
                <div className={styles.previewHeader}>
                    <div className={styles.previewTitle}>
                        <Icon icon="FILE_TEXT" className={styles.icon} />
                        <span className={styles.title}>Preview Document</span>
                    </div>
                    <div className={styles.actions}>
                        <BaseButton
                            variant="secondary"
                            title="Download"
                            onClick={() => {
                                refetch().then(() => {
                                    downloadFileFromUrl(document?.documentUrl, `${document?.name}.pdf`)
                                })
                            }}
                            loading={isFetching}
                        />
                        <BaseButton title="Document Details" onClick={goDetails} />
                        <div className={styles.actionClose} onClick={onClose}>
                            <Icon icon="CLOSE" color="#000" className={styles.closeIcon} />
                        </div>
                    </div>
                </div>
                <PDFViewer fileSrc={document?.documentUrl} options={{zoom: "fitToWidth", view: "fitToWidth"}} />
                <BaseLoading isShow={isLoading} />
            </div>
        </BasePopup>
    )
}
